import {Box} from '@mui/material';
import {useContext} from 'react';
import {SeniorTabs} from '../../../../../../components/senior-tabs/senior-tabs';
import {AuthContext} from '../../../../../../contexts/auth/context';
import {AuthContextType} from '../../../../../../contexts/auth/types';
import {SeniorTabsType} from '../../../../../../enums/senior-tabs-type';

export default function SeniorSystemAdministratorOfficeScreen() {
  // Get context
  const authContext: AuthContextType = useContext(AuthContext);

  return (
    <Box
      sx={{
        background: '#FFFFFF',
        width: '100%',
        padding: {xs: '40px 10px 51px 10px', md: '40px 66px 51px 66px'},
        borderRadius: '10px',
      }}
    >
      <SeniorTabs
        type={
          authContext.state.session?.systemAdministratorProfile?.analyticsAdmin === true
            ? SeniorTabsType.SystemAdministrator_Statistics
            : SeniorTabsType.SystemAdministrator_WithoutStatistics
        }
      />
    </Box>
  );
}
